// tslint:disable:max-line-length
import * as React from 'react';

export const ArmorIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
      <path fill="#FFF" fillRule="evenodd"
            d="M11.148 2.067C9.633 3.69 7.874 6.025 6.834 7.895A13.788 13.788 0 0 0 5.17 5.738l-.23-.247L3.7 6.955l.185.195c.925.973 2.14 2.715 2.745 3.98l.283.593.263-.603a35.272 35.272 0 0 1 5.158-8.364l.16-.193-.006-.008c.504.167 1.008.315 1.512.445l-.42 4.2a9 9 0 0 1-6.11 7.643L7 15l-.47-.157A9 9 0 0 1 .42 7.2L0 3c1.167-.3 2.333-.7 3.5-1.2C4.667 1.3 5.833.7 7 0c1.167.7 2.333 1.3 3.5 1.8.216.092.432.181.648.267z"/>
    </svg>
  );
};
